import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_PHARMA_ACTIVITY_PLANNING_REPORTS_API, RQ_GET_PHARMA_MARKETING_ACTIVITY_REPORTS_API, RQ_GET_ROB_VALUE_FOR_CHEMIST_REPORTS_API} from '@app/reactQuery/apis/constants';

export const RQUseGetPharmaMarketingActivityReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_pharma_marketing_activity_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_PHARMA_MARKETING_ACTIVITY_REPORTS_API,
        null,
        certificate,
        {
          itemId: divisionId,
          fromYearMonth: startDate,
          toYearMonth: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetPharmaActivityPlanningReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_pharma_activity_planning_report_data', payload],
    enabled: !!payload?.startDate && !!payload?.endDate,
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_PHARMA_ACTIVITY_PLANNING_REPORTS_API,
        null,
        certificate,
        {
          itemId: divisionId,
          fromYearMonth: startDate,
          toYearMonth: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetROBValueForChemistReportData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_rob_value_for_chemist_report_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, divisionId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_ROB_VALUE_FOR_CHEMIST_REPORTS_API,
        null,
        certificate,
        {
          itemId: divisionId,
          fromYearMonth: startDate,
          toYearMonth: endDate,
        },
        signal,
      );
    }, ...options,
  });
};
